export const RELIGION_OTHER_VALUE = 'OTHER';
export const CATEGORY_OTHER_VALUE = 'OTHER';

export const RELIGION_OPTIONS = [
  { label: 'Hindu', value: 'HINDU' },
  { label: 'Muslim', value: 'MUSLIM' },
  { label: 'Christian', value: 'CHRISTIAN' },
  { label: 'Sikh', value: 'SIKH' },
  { label: 'Buddhist', value: 'BUDDHIST' },
  { label: 'Jain', value: 'JAIN' },
  { label: 'Parsi', value: 'PARSI' },
  { label: 'Other', value: RELIGION_OTHER_VALUE }
];

export const CATEGORY_OPTIONS = [
  { label: 'General / Open Category (OC)', value: 'OC' },
  { label: 'Other Backward Class (OBC/BC)', value: 'OBC_BC' },
  { label: 'Scheduled Caste (SC)', value: 'SC' },
  { label: 'Scheduled Tribe (ST)', value: 'ST' },
  { label: 'Other', value: CATEGORY_OTHER_VALUE }
];
